export default __webpack_public_path__ + "static/media/birthanniversery.ad6a2d69.png";